export const CUSTOM_UPSCALE_IMAGINATION_STRENGTH_PRESET = "CUSTOM";

type PresetParams = {
  creativity: number;
  resemblance: number;
};

export type UpscaleImaginationStrengthPresets = {
  LOW: PresetParams;
  MEDIUM: PresetParams;
  HIGH: PresetParams;
};

export type UpscaleImaginationStrengthPreset =
  | keyof UpscaleImaginationStrengthPresets
  | typeof CUSTOM_UPSCALE_IMAGINATION_STRENGTH_PRESET;
